import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';
import { useSearchParams } from 'react-router';

import { useAppSelector } from 'src/app/store/hooks';
import { DataGrid } from 'src/common/DataGrid';
import { usePaginationState } from 'src/common/DataGrid/usePaginationState';
import { useVehiclesListQuery } from 'src/common/external/bambi-api/bambiApi';

import { columns } from './columns';
import VehicleTagModal from './tags/VehicleTagModal';
import { VehicleEmptyState } from './VehicleEmptyState';

export function VehicleManagementRoute() {
  const vehicleSearchTerm = useAppSelector(
    (state) => state.fleet.vehicleSearchTerm
  );

  const vehicleTags = useAppSelector((state) => state.fleet.vehicleTags);
  const ordering = useSearchParams()[0].get('ordering');

  const { pagination, handlePaginationChange, paramsWithPage } =
    usePaginationState({
      tags: vehicleTags.join(','),
      search: vehicleSearchTerm,
      ordering: ordering || undefined,
    });

  const { data: vehicles, isLoading } = useVehiclesListQuery(paramsWithPage);

  return (
    <>
      {isLoading ? (
        <div className="my-72 flex justify-center">
          <LoadingIndicator />
        </div>
      ) : (
        <>
          <div>
            <DataGrid
              dataTestId="vehicle-management-table"
              tableId="vehicle-management"
              columns={columns}
              data={vehicles?.results || []}
              pagination={pagination}
              totalCount={vehicles?.count || 0}
              handlePaginationChange={handlePaginationChange}
              emptyState={<VehicleEmptyState />}
              getRowId={(row) => row.id}
            />
            <VehicleTagModal />
          </div>
        </>
      )}
    </>
  );
}
